<template>
  <div class="memberPie" ref="echarts"></div>
</template>

<script>
import { EchatsMixin } from "@/utils/echarts";

export default {
  mixins: [EchatsMixin],
  props: ["takePaper", "timePicker"],
  name: "paperMonthEcharts",
  data() {
    return {};
  },
  watch: {
    takePaper: {
      handler(n) {
        if (n) {
          this.monthPaper(n);
        }
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    monthFormatProcessing(moto) {
      let data = [];
      let days = "";
      for (let i = 0; i < moto.length; i++) {
        let numsum = 0;
        days = moto[i].date;
        moto[i].countList.forEach(item => {
          numsum += parseInt(item.num);
        });
        data.push([days, numsum.toString()]);
      }
      return data;
    },
    monthPaper(moto) {
      if (!moto) return;
      let myChart = this.resizeEcharts();

      let option = {
        tooltip: {
          position: "top", //鼠标悬浮提示框位置
          formatter:function(p){
            let message='本日合计：'
            let col = {
              fontSize: 16,
              textShadowBlur: 5,
              textShadowColor: '#000',
              textShadowOffsetX: 3,
              textShadowOffsetY: 3,
              color: '#fff'
            }
            let msgDateNum = `
            <div style="backgroundColor:red">
            <span style="${col}">
              ${p.data[0]}
            </span>
            <br>
            <hr color=${p.color}>
            ${p.data[1] == '0'  ? "本日暂无使用" : `${p.marker}${message}${p.data[1]}` }
            </div>
            `
            return msgDateNum
          },
        },
        visualMap: {
          name:'使用频次',
          type: "piecewise",
          calculable: true,
          orient: "horizontal",
          left: "center",
          top: 5,
          pieces: [
            {
              lte:0,
              color: '#EBEEF5'
            },
            {
              gt: 0,
              lte: 5,
              color: '#ffcc33'
            },
            {
              gt: 5,
              lte: 15,
              color: '#ff9933'
            },
            {
              gt: 15,
              lte: 25,
              color: ' #ff6633'
            },
            {
              gt: 25,
              color: '#ff3333'
            }
          ],
        },
        calendar: [
          {
            orient: "vertical",
            yearLabel: {
              margin: 40,
              show: false
            },
            dayLabel: {
              firstDay: 1,
              nameMap: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              position: "start"
            },
            monthLabel: {
              nameMap: "cn"
            },
            top: 75,
            left: 55,
            right: 45,
            cellSize: ["auto"],
            range: this.timePicker
          }
        ],
        series: [
          {
            name: "使用频次",
            type: "heatmap",
            coordinateSystem: "calendar",
            data: this.monthFormatProcessing(moto),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      myChart.clear();
      myChart.setOption(option, true);
    }
  },

  created() {}
};
</script>

<style scoped>
.memberPie {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/html/paperMonthEcharts.vue